import base_url from '../config';
import axios from 'axios';
const api_url = base_url + 'api/admin/login';

export const login = async (data) => {
  try {
    console.log('baseurl',base_url,'api_url',api_url);
    const response = await axios.post(api_url, data);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      return { error: error.response.data.message };
    }
    return { error: 'Something went wrong. Please try again.' };
  }
};